<template>
  <div class="auth">
    <div class="auth-header">
      <div class="auth-header__logo">
        <TalentLogo />
      </div>
    </div>

    <div class="auth__wrapper">
      <div class="auth__col auth__col--bg" />

      <div class="auth__col auth__col--form">
        <div class="auth__form">
          <slot />
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import TalentLogo from '@/components/icons/TalentLogo.vue'
</script>

<style lang="scss" scoped>
.auth {
  font-family: Manrope, sans-serif;
  position: relative;
  min-height: 100vh;

  .auth-header {
    position: absolute;
    width: 100%;
    top: var(--space-32);
    padding-left: calc(var(--space-16) * 2);
    z-index: 3;

    @include desktop-down {
      top: var(--space-20);
      padding-left: var(--space-20);
    }


    @include tablet-up-down {
      &__logo svg {
        color: var(--color-white) !important;
      }
    }

    @include phone {
      position: static;
      background-color: var(--color-white);
      padding: var(--space-16) var(--space-24);
    }

    &__logo {
      display: inline-flex;
      max-width: 208px;
      color: var(--color-brand-500);
    }
  }

  .auth__wrapper {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    min-height: 100vh;
    direction: rtl;

    * {
      direction: ltr;
    }

    @include desktop-down {
      grid-template-columns: 1fr;
      background-color: var(--color-brand-500);
    }

    @include phone {
      height: calc(100vh - 82px);
      min-height: 0;
      display: flex;
      flex-direction: column;
    }
  }

  .auth__col--bg {
    background-color: var(--color-brand-500);
    background-image: url('@/assets/images/auth/rri-rt-background-desktop.png');
    background-repeat: no-repeat;
    background-position: right top;
    background-size: contain;

    @include desktop-down {
      min-height: 40vh;
      background-image: url('@/assets/images/auth/rri-rt-background-mobile.png');
      background-size: 80%;
    }

    @include phone {
      min-height: 32vh;
      max-height: 38vh;
      background-image: url('@/assets/images/auth/rri-rt-background-mobile.png');
      background-position: right top;
      background-size: contain;
    }
  }

  .auth__col--form {
    padding-top: 19%;

    @include desktop-down {
      padding-top: 0;
    }

    @include phone {
      margin-top: auto;
      padding: 0;
    }
  }

  .auth__form {
    margin-left: calc(50vw - 570px);
    width: 100%;
    max-width: 460px;
    padding: 0 var(--space-20);
    background-color: var(--color-white);

    @include widescreen-down {
      margin-left: auto;
      margin-right: auto;
    }

    @include desktop-down {
      padding: var(--space-32) var(--space-20);
      border-radius: var(--space-24);
    }

    /* MOBILE — as per mockup */
    @include phone {
      max-width: 100%;
      border-radius: var(--space-24) var(--space-24) 0 0;
      padding: var(--space-24);
    }
  }
}
</style>
